// import defaultAvatar from "~/assets/user/ad.png";
import { User } from "~/models";
import activities from "./activities";

const defaultAvatar = undefined;

const users: User[] = [
    {
        id: "john",
        name: "John",
        avatar: defaultAvatar,
        activities: [activities[0], activities[1], activities[2]],
    },
    {
        id: "alice",
        name: "Alice",
        avatar: defaultAvatar,
        activities: [activities[3], activities[1], activities[2]],
    },
    {
        id: "jack",
        name: "Jack",
        avatar: defaultAvatar,
        activities: [activities[3], activities[4], activities[2]],
    },
    {
        id: "joe",
        name: "Joe",
        avatar: defaultAvatar,
        activities: [activities[3], activities[1], activities[2]],
    },
    {
        id: "maria",
        name: "Maria",
        avatar: defaultAvatar,
        activities: [activities[3], activities[4], activities[2]],
    },
    {
        id: "alex",
        name: "Alex",
        avatar: defaultAvatar,
        activities: [activities[1], activities[4], activities[2]],
    },
    {
        id: "philip",
        name: "Philip",
        avatar: defaultAvatar,
        activities: [activities[1], activities[3], activities[2]],
    },
    {
        id: "tim",
        name: "Tim",
        avatar: defaultAvatar,
    },
    {
        id: "anton",
        name: "Anton",
        avatar: defaultAvatar,
    },
    {
        id: "anna",
        name: "Anna",
        avatar: defaultAvatar,
    },
    {
        id: "lars",
        name: "Lars",
        avatar: defaultAvatar,
    },
];

export default users;
